module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs is-toggle is-centered"
  }, [_c('ul', [_c('router-link', {
    attrs: {
      "to": "/humidity/hour",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Hour")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/humidity/day",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Day")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/humidity/week",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Week")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/humidity/month",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Month")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/humidity/year",
      "active-class": "is-active",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Year")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c02d68a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HumidityRanges.vue
// module id = 375
// module chunks = 1